import { ReactElement, useEffect } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { Header, SideBar } from '../..';
import { useAuth } from '../../../contexts/auth';
import { useHistory, useLocation } from 'react-router-dom';

interface Props {
    children: JSX.Element;
    window?: () => Window;
}

export default function Dash({ children }: Props): ReactElement {
    const history = useHistory();
    const { pathname } = useLocation();
    const { currentTicketOffice, isTicketOfficeListLoading } = useAuth();

    useEffect(() => {
        if (!isTicketOfficeListLoading && !currentTicketOffice) {
            localStorage.setItem("pathname_redirect_gov", pathname);
            history.push("/");
        }
    }, [isTicketOfficeListLoading, currentTicketOffice, history, pathname]);

    if (isTicketOfficeListLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" style={{ height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box
            display="flex"
            style={{ background: "#F7F8FC", minHeight: "100vh", overflow: "auto" }}
        >
            <SideBar />
            <Box style={{ width: "100%", overflow: "auto" }}>
                <Header />
                <Box style={{ width: "100%", overflow: "auto" }}>{children}</Box>
            </Box>
        </Box>
    );
}
